const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

async function request(path, { method = 'GET', body, token } = {}) {
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    const res = await fetch(`${API_URL}${path}`, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
    });

    if (res.status === 204) return null;

    const data = await res.json().catch(() => null);
    if (!res.ok) {
        const message = (data && data.error) || `La solicitud falló con estado ${res.status}`;
        throw Object.assign(new Error(message), data || {});
    }
    return data;
}

export function productSocketUrl(productId, token) {
    const wsBase = API_URL.replace(/^http/, 'ws');
    return `${wsBase}/ws?productId=${productId}&token=${encodeURIComponent(token)}`;
}

export async function uploadImage(file, token) {
    const formData = new FormData();
    formData.append('image', file);

    const res = await fetch(`${API_URL}/store/upload`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        body: formData,
    });

    const data = await res.json().catch(() => null);
    if (!res.ok) {
        throw new Error((data && data.error) || `La subida falló con estado ${res.status}`);
    }
    return data;
}

export async function uploadStoreLogo(file, token) {
    const formData = new FormData();
    formData.append('image', file);

    const res = await fetch(`${API_URL}/store/logo`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        body: formData,
    });

    const data = await res.json().catch(() => null);
    if (!res.ok) {
        throw new Error((data && data.error) || `La subida falló con estado ${res.status}`);
    }
    return data;
}

export default request;
